module.exports = __webpack_public_path__ + "img/full5-min.4f6afaa1.png";